<template>
  <div>
    <aha-modal @hide="$emit('hide')" :title="'Request Additional Licenses'">
      <label for="email" class="block mb-1 font-bold">{{ $i18nPresenter.t('Email') }}:</label>
      <aha-input
        type="email"
        id="email"
        class="mb-4 email-input"
        :value="currentUser.email"
        :highlightOnHover="false"
        :disabled="true"
      />

      <label for="quantity" class="block mb-1 font-bold">{{ $i18nPresenter.t('Quantity') }}:</label>
      <aha-input
        type="number"
        id="quantity"
        v-model="quantity"
        class="mb-4"
      />

      <label for="message" class="block mb-1 font-bold">{{ $i18nPresenter.t('Message') }}:</label>
      <aha-textarea
        :placeholder="$i18nPresenter.t('Enter your message')"
        id="message"
        v-model="message"
        class="mb-4"
      ></aha-textarea>

      <aha-button @click="submitRequest" :submitting="isSubmitting" class="w-full mb-3">
        {{ $i18nPresenter.t('Submit') }}
      </aha-button>
      <p class="text-center">
        {{ $i18nPresenter.t('We will contact you shortly') }}.
      </p>
    </aha-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import PaymentLocalizationMixin from '@/components-v2/my-plan/user-pricing-v2/PaymentLocalizationMixin'
import util from '@/util'

export default {
  mixins: [PaymentLocalizationMixin],
  data() {
    return {
      quantity: 3,
      message: '',
      isSubmitting: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },

  methods: {
    ...mapActions([
      'hookBulkPricingAction',
    ]),
    validateRequest() {
      if (this.quantity < 1) {
        throw new Error('Quantity must be greater than 0')
      }
    },
    async submitRequest() {
      try {
        this.isSubmitting = true
        this.validateRequest()
        const payload = {
          planType: this.currentUser.plan,
          numOfLicenses: this.quantity,
          email: this.currentUser.email,
          requirement: this.message,
          isCSCreatedTeam: true,
        }
        await this.hookBulkPricingAction(payload)
        util.showToastSuccess('Request submitted successfully')
        this.$emit('hide')
      } catch (e) {
        Sentry.captureException(e)
        util.showToastError(`Request submitted failed: ${e.message}`)
      } finally {
        this.isSubmitting = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.email-input {
  & ::v-deep .aha-input {
    @apply text-base-80 bg-base-20 cursor-not-allowed;
  }
}
</style>
